import { Box } from '@mui/material';
import { Card, CardContent } from './Card';
import { Typography } from './Typography';

export const ErrorCard = () => {
  return (
    <Card>
      <CardContent>
        <Box p={4}>
          <Typography color='error'>No data. Something went wrong. Please try again.</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
